export const getDataFromLocaleStorage = (key: string) => {
  if (!(typeof window === 'undefined')) {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
  }
  return null;
};
